// @flow
import React from "react";
import "./stylesheets/FormField.scss";

class FormField extends React.PureComponent<{
  formKey: string,
  value: string,
  title: string,
  rows?: string,
  placeholder?: string,
  disabled?: boolean,
  onChangeCallback: Function
}> {
  static defaultProps = {
    rows: "1",
    defaultValue: "",
    placeholder: ""
  };

  onChange: Function = event => {
    const { target: { value } } = event;
    const { formKey } = this.props;
    this.props.onChangeCallback(formKey, value);
  };

  render() {
    const {
      formKey,
      rows,
      placeholder,
      title,
      value,
      disabled = false
    } = this.props;
    const inputProps = {
      className: "FormField__Input",
      type: "text",
      id: formKey,
      rows,
      placeholder,
      onChange: this.onChange,
      value,
      disabled
    };
    return (
      <div className="FormField">
        <label htmlFor={formKey}>
          <span className="FormField__Label">{title}</span>
          {Number(rows) < 2 ? (
            <input {...inputProps} />
          ) : (
            <textarea {...inputProps} />
          )}
        </label>
      </div>
    );
  }
}

export default FormField;



// WEBPACK FOOTER //
// ./node_modules/@localytics/push-message-builder/src/components/FormField.jsx